import { SearchQueryOrderDirection } from "types/generated";

export const INITIAL_SORT_OPTION = "createdAt";
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
export const FILTER_TYPE = "intent-projects";

enum IntentProjectSuggestions {
  NAME = "name",
  SLUG = "slug",
  SPACE = "space",
  IS_LOCKED = "is_locked",
}

export const INTENT_PROJECTS_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  [IntentProjectSuggestions.NAME]: "Intent project",
  [IntentProjectSuggestions.SPACE]: "Space",
  [IntentProjectSuggestions.SLUG]: "Intent project ID",
  [IntentProjectSuggestions.IS_LOCKED]: "Locked",
};
